import type { FC, ReactNode } from 'react'

import { Check, X } from 'lucide-react'

import { Glow } from '@/components/generals/glow'
import { Reveal } from '@/components/generals/reveal'
import { Section } from '@/components/generals/section'
import { Wordmark } from '@/components/generals/wordmark'
import { SectionHeading } from '@/components/generals/section-heading'
import { comparison } from '@/constants/content'

export const Comparison: FC = (): ReactNode => {
    return (
        <Section id='comparison'>
            <SectionHeading
                eyebrow='Comparison'
                segments={[
                    { text: 'But, why would you want to work' },
                    { text: 'with us?', serif: true }
                ]}
            />

            <Reveal
                y={28}
                blur={10}
                delay={0.1}
                stagger={0.14}
                className='mt-14 grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:mt-20'
            >
                <div className='flex flex-col gap-7 rounded-2xl bg-surface-1 p-7 ring-1 ring-white/8 sm:p-8'>
                    <h3 className='text-lg leading-none font-medium tracking-[-0.02em] text-white/40'>
                        Other Agencies
                    </h3>

                    <ul className='flex flex-col gap-4'>
                        {comparison.others.map((item) => (
                            <li
                                key={item}
                                className='flex items-center gap-3 text-[15px] leading-[1.4] tracking-[-0.01em] text-white/40'
                            >
                                <span
                                    aria-hidden='true'
                                    className='flex size-6 shrink-0 items-center justify-center rounded-full bg-white/6 text-white/40 ring-1 ring-white/8'
                                >
                                    <X className='size-3.5' />
                                </span>

                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='relative flex flex-col gap-7 overflow-hidden rounded-2xl bg-surface-1 p-7 ring-1 ring-white/12 sm:p-8'>
                    <Glow
                        variant='card'
                        className='top-[-400px] right-[-260px] opacity-90'
                    />

                    <h3 className='relative z-1 flex items-center'>
                        <Wordmark
                            markClassName='size-6'
                            textClassName='text-lg'
                        />
                    </h3>

                    <ul className='relative z-1 flex flex-col gap-4'>
                        {comparison.ours.map((item) => (
                            <li
                                key={item}
                                className='flex items-center gap-3 text-[15px] leading-[1.4] tracking-[-0.01em] text-white'
                            >
                                <span
                                    aria-hidden='true'
                                    className='flex size-6 shrink-0 items-center justify-center rounded-full bg-[#8b5cf6] text-white shadow-[0_0_20px_-4px_rgba(139,92,246,0.8)]'
                                >
                                    <Check className='size-3.5' />
                                </span>

                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </Reveal>
        </Section>
    )
}
